export const REGISTRATION = 'Register';
export const CONFIRM_ACCOUNT = 'Confirm Account';
export const LOGIN = 'Sign in';
export const FORGOT_PASSWORD = 'Forgot password?';
export const ALL_FIELDS_REQUIRED = 'All fields are required.';
export const PASSWORD_DO_NOT_MATCH = "Those passwords didn't match. Please try again.";
export const ACCOUNT_NOT_ACTIVE = 'Your account is pending approval or has been disabled';
//# sourceMappingURL=index.js.map